import { useContext, useEffect, useState } from "react"
import { useOutletContext } from 'react-router';
import { useTranslation } from 'react-i18next';

import api from 'shared/topchef-api-places';
import { Lead, NotificationType } from "shared/topchef.types"
import { PlaceOutletContextType } from "../home/PlacesHome"
import Loading from "pages/shared/loading/Loading"

import { NotificationContext } from "shared/NotificationContext"
import MoreDetailsCellRenderer from "pages/shared/more-details-renderer/MoreDetailsCellRenderer";
import BriefsMarketMenu from "pages/places/briefs-market-menu/BriefsMarketMenu";
import { useErrorBoundary } from "react-error-boundary";
import BriefsList from "pages/shared/briefs-list/BriefsList"


export interface LeadsToCloseLoaderProps {
  title: string,
  showMenu: boolean,
  limit: number | null,
  paginateResults: boolean,
  height: string
}

const LeadsToCloseLoader = (props: LeadsToCloseLoaderProps) => {

  const { t } = useTranslation();
  const [loggedInPlace] = useOutletContext<PlaceOutletContextType>();

  const notificationContext = useContext(NotificationContext);
  const { triggerNotification } = notificationContext;

  const [leadsLoaded, setLeadsLoaded] = useState<boolean>(false);
  const [leads, setLeads] = useState<Lead[]>([]);
  
  const { showBoundary } = useErrorBoundary();

  useEffect(() => { // eslint-disable-line react-hooks/exhaustive-deps

    async function loadLeads() {
      try {
        const leads: Lead[] = await api.loadLeadsToClose(loggedInPlace!.id, props.limit);
        setLeads(leads);
        setLeadsLoaded(true);
      } catch (error: any) { 
        const newError = new Error(t('apiErrors.loadLeadsToClose', { details: error.message }) as string);
        triggerNotification({type: NotificationType.error, message : newError.message});
        return showBoundary(newError);
      } 
    }

    if (leadsLoaded) {
      return;
    }
    loadLeads();

  }, [leadsLoaded, leads, loggedInPlace, triggerNotification, showBoundary, props.limit]); // eslint-disable-line react-hooks/exhaustive-deps


  const moreDetailsRenderer = (params: any) => {
    const leadId: string = params.data.id;
    return (
      <MoreDetailsCellRenderer url={`/places/leads/to-close/${leadId}`} label={t('actionLabels.close')}  />
    );
  };


  if (!leadsLoaded) {
    return (
      <Loading />
    );
  }

  return (
    <div className="page-briefs-achieved container p-5">
      <div id="lead_sidebar" className="d-flex">
        <ul className="nav nav-pills flex-column mb-auto">
          <li className="nav-item"> <a href="/places/share-a-lead" type="button" className="btn btn-outline-primary nav-link add-brief-link">{t('common.addBrief')}</a></li>
        </ul>
      </div>

      <h5 className="mb-3">{props.title}</h5>

      {props.showMenu && <BriefsMarketMenu loggedInPlace={loggedInPlace}/> }
      
      <BriefsList leads={leads} height={props.height} paginateResults={props.paginateResults} detailsRenderer={moreDetailsRenderer}  />

    </div>
  );

}

export default LeadsToCloseLoader;
